import { render, staticRenderFns } from "./Protokolle.vue?vue&type=template&id=6c54b435&"
import script from "./Protokolle.vue?vue&type=script&lang=js&"
export * from "./Protokolle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports